import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { EmptyState, buttonStyles } from "../components/ui";

export function NotFoundPage() {
  const { t } = useTranslation("common");
  return (
    <EmptyState
      title={t("notFound.title")}
      description={t("notFound.description")}
      action={
        <Link className={buttonStyles("secondary", "md")} to="/">
          {t("notFound.back")}
        </Link>
      }
    />
  );
}
